import {GlAccount} from "../../../hooks/useGLAccounts.ts";
import {Money, toMoneyFromCents} from "../../../lib/Money.ts";
import type {Subledger} from "../SubledgerSelector";
import type { CurrencyEnum } from '../../../generated/enums.ts';

export interface LineItem {
    id: string;
    originalId?: string;
    _key: number;
    gla: GlAccount;
    description: string;
    debit: Money | null;
    credit: Money | null;
    currency: CurrencyEnum;
    isBankLine?: boolean;
    bankAccountId?: string;
    subledger?: Subledger | null;
}

export function lineAmountCents(amount: Money | null): number {
    return amount?.signed_amount ?? 0;
}

export function amountsForBalance(
    balance: number | null,
    currency: CurrencyEnum,
): { debit: Money | null; credit: Money | null } {
    if (balance === null) return { debit: null, credit: null };
    return {
        debit: balance > 0 ? toMoneyFromCents(balance, currency) : null,
        credit: balance < 0 ? toMoneyFromCents(-balance, currency) : null,
    };
}

export function hasBookableAmount(balance: number | null): boolean {
    return balance !== null && balance !== 0;
}
